import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWallet3"><Path d="M16.5 8.5H6C4.61929 8.5 3.5 7.38071 3.5 6C3.5 4.61929 4.61929 3.5 6 3.5H16.5V8.5ZM16.5 8.5H20.5V20.5H6.5C4.84315 20.5 3.5 19.1569 3.5 17.5V6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 15.125C15.8452 15.125 16.125 14.8452 16.125 14.5C16.125 14.1548 15.8452 13.875 15.5 13.875C15.1548 13.875 14.875 14.1548 14.875 14.5C14.875 14.8452 15.1548 15.125 15.5 15.125Z" fill="currentColor" stroke="currentColor" strokeWidth="0.25"/></CentralIconBase>;
});

export default IconWallet3;
